import { RegistrationStep, ServerOnlyRegistrationStep } from '../../../../shared-core/services/app/searchRoutes';

export function isClientOnlyRegistrationStep(
  step: RegistrationStep
): step is Exclude<RegistrationStep, ServerOnlyRegistrationStep> {
  return step !== 'verify-email';
}
